import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const CantidadSedesxCompaniasFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='CANTIDAD SEDES' htmlFor='input-cantidadSedesxCompanias' md={12} />
      <Col md={12}>
        <Field name='cantidadSedesxCompanias'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              id='input-cantidadSedesxCompanias'
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CantidadSedesxCompaniasFormGroup)
